import { useSelector } from "react-redux";

import { Link } from "react-router-dom";
import { Button } from "reactstrap";

import { issuerUrls } from "config/endPoints";
import { staticData } from "managers/staticDataManager";
import { withLang } from "managers/routeManager";

const BackToLogin = () => {
  const state = useSelector((state) => state);

  return (
    <div className="forgot">
      <Link to={withLang(state, issuerUrls.LOGIN_URL)}>
        <Button className="btn-link" color="danger" type="button">
          {staticData.loadTerms(state, "VW_ISSUER_BackToLogin_Btn")}
        </Button>
      </Link>
    </div>
  );
};

export default BackToLogin;
